export default __webpack_public_path__ + "static/media/ic_info_gray.9d13656f.svg";